export default __webpack_public_path__ + "static/media/sample_ceritificate.1adc63e3.png";